import { useEffect, useState } from "react";
import softwareServices from "./../../../services/alumnos/softwareServices";
import { message } from "antd";


const useSoftware = (inicialData = []) => {
    const [CatalogSoftware, setCatalogSoftware] = useState([]);
    const [CatalogTipoDominio, setCatalogTipoDominio] = useState([]);
    const [CatalogUso, setCatalogUso] = useState([]);
    const [loading, setLoading] = useState(false);

    const [crearSoftware, setCrearSoftware] = useState(false);
    const [editarSoftware, setEditarSoftware] = useState({});


    const getSoftwareMe = async () => {
        setLoading(true);
        const response = await softwareServices.getSoftwareMe();
        setLoading(false);
        if (!response.success) return;
        setCatalogSoftware(response.data);
    };

    const getCatalogUso = async () => {
        setLoading(true);
        const response = await softwareServices.getUso();
        setLoading(false);
        if (!response.success) return;
        setCatalogUso(response.data);
    };

    const getCatalogTipoDominio = async () => {
        setLoading(true);
        const response = await softwareServices.getTipoDominio();
        setLoading(false);
        if (!response.success) return;
        setCatalogTipoDominio(response.data);
    };

    useEffect(() => {
        getCatalogUso();
        getCatalogTipoDominio();
    }, []);

    const onEdit = (record) => {
        setEditarSoftware(record);
    }
    const onCancel = () => {
        setCrearSoftware(false);
        setEditarSoftware({});
    }

    const onDelete = async (id) => {
        const response = await softwareServices.deleteSoftwareMe(id);
        if (!response.success) return false;
        message.success("Eliminado correctamente");
        await getSoftwareMe();
        return true;
    }

    const onSave = async (data) => {
        const finalData = editarSoftware?.id_software ? { ...data, id_software: editarSoftware.id_software } : data;

        if (finalData.id_software) {
            const response = await softwareServices.editSoftwareMe(finalData);
            if (!response.success) return false;
        } else {
            const response = await softwareServices.createSoftwareMe(finalData);
            if (!response.success) return false;
        }

        message.success("Guardado correctamente");
        setCrearSoftware(false);
        setEditarSoftware({});
        await getSoftwareMe();
        return true;
    }

    const onCreateSoftware = () => {
        setCrearSoftware(true);
    }

    useEffect(() => {
        setCatalogSoftware(inicialData);
    }, [inicialData]);


    return {
        CatalogSoftware,
        CatalogUso,
        CatalogTipoDominio,
        loading,
        crearSoftware,
        editarSoftware,
        onCreateSoftware,
        onSave,
        onEdit,
        onDelete,
        onCancel,
    };

}

export default useSoftware;